import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { Factura } from 'src/app/Models/factura/factura';
import { AddFacturaComponent } from './add-factura/add-factura.component';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { ClienteDialogComponent } from '../cliente/cliente-dialog/cliente-dialog.component';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment';
import { Personal } from 'src/app/Models/personal/personal';
import { AnularFacturaComponent } from './anular-factura/anular-factura.component';
import { PrintPedidoComponent } from '../print/print-pedido/print-pedido.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePersonalComponent } from './change-personal/change-personal.component';

@Component({
  selector: 'app-facturacion',
  templateUrl: './facturacion.component.html',
  styleUrls: ['./facturacion.component.css']
})
export class FacturacionComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('txtdireccion', null) txtdireccion: ElementRef;
  @ViewChild(AddFacturaComponent, null) newfactura: AddFacturaComponent;
  @ViewChild(ClienteDialogComponent, null) newcliente: ClienteDialogComponent;

  @ViewChild(PrintPedidoComponent, null) printpedido: PrintPedidoComponent;
  @ViewChild(AnularFacturaComponent, null) frmAnulacion: AnularFacturaComponent;
  public usuario: Usuario = new Usuario();
  public facturas: any[] = [];
  public pagarticulo: any = 0;
  public tipo_filtro: number = 0;
  public filtro: Filtro = new Filtro();
  public vendedor: Personal = new Personal()
  public listvendedores: Personal[] = []
  public clientes: Cliente[] = []
  public cliente: Cliente = new Cliente();
  public fechaHoraActual = new Date();
  public search = { top: 10, clase: 0, subclase: 0, subgrupo: 0, nombre: '', codigo: '', opcion: 'nombre', scale: 'DESC', fechaprogd: this.data.DateNowCurrent(), fechaprogh: this.data.DateNowCurrent() }
  public alertType: AlertType = new AlertType();
  public articulos : any[] = [];
  public totalCantidad: number;

  constructor(private title: Title, private data: DataService,private modalService: NgbModal, private notify: NotifyService, private auth: AuthService, private route: Router, private cdRef: ChangeDetectorRef) {
    const firstDayOfMonth = new Date(this.fechaHoraActual.getFullYear(), this.fechaHoraActual.getMonth(), 1);
    this.filtro.fecini = moment(this.fechaHoraActual).format('YYYY-MM-DD');
    this.filtro.fecfin = moment(this.fechaHoraActual).format('YYYY-MM-DD');
    this.filtro.idsucursal = data.getSucursalId()
    this.filtro.incluir_articulos = true
    
    this.mostrarFiltro()
  }

  ngOnInit() {
    this.title.setTitle('Lista de pedidos | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    // this.filtro.idvende = this.usuario.idpersonal.idnivel == 1 ? null : this.usuario.idpersonal.idpersonal;
    this.getClientes()
    this.getVendedores()
    //this.getFacturas();
  }

  getVendedores() { this.data.GetSimple(this.data.api.personal).subscribe(r => this.listvendedores = r) }
  getClientes() {
    this.data.GetSimple(this.data.api.cliente).subscribe(r => this.clientes = r.clientes || r.data || r)
  }


  getFacturas() {
    this.data.GetSimple(this.data.api.factura).subscribe(r => {
      console.log(r);

      this.facturas = r;
    })
  }
  reiniciarFiltro() {
    this.filtro = {
      ...this.reiniciarObjetoFiltro(this.filtro), // Copia los campos tipofecha, fecini, fecfin
    };
  }

  // Función para reiniciar el objeto filtro manteniendo tipofecha, fecini, fecfin
  private reiniciarObjetoFiltro(obj: Filtro): Partial<Filtro> {
    const { tipofecha, fecini, fecfin } = obj;
    return { tipofecha, fecini, fecfin };
  }

  showfrmcliente() {
    this.newcliente.show(() => {
      this.cliente = this.newcliente.cliente;
    })
  }

  mostrarFiltro() {
    console.log(this.filtro);
    this.data.Post('filtrardoc/Factura', this.filtro).subscribe(r => {
      console.log(r);
      if (r.status === 'error') {
        this.facturas = [];
        this.articulos = []
        // this.data.notify(r.message, "Error", this.alertType.error);

      } else {
        this.facturas = r.data;
        this.articulos = r.articulos_vendidos;
        this.articulos['total_cantidad'];
      }


    }), (e => { this.data.notify(e.message, "Error", this.alertType.error); })

  }

  print(factura: Factura) {
    if (factura) {
      switch (factura.documen) {
        case 'BOL':
          this.route.navigateByUrl('/printer/boleta/' + factura.idfactura);
          break;
        case 'FAC':
          this.route.navigateByUrl('/printer/factura/' + factura.idfactura);
          break;
        case 'PED':
          this.printpedido.facturaId = factura.idfactura.toString();
          this.printpedido.getEmpresa();
          this.printpedido.getFactura()
            .then(() => {
              this.cdRef.detectChanges(); // Forzar detección de cambios
              return new Promise(resolve => setTimeout(resolve, 0)); // Esperar ciclo de eventos
            })
            .then(() => this.printpedido.generarTicket())
            .catch(error => {
              console.error("Error en el flujo:", error);
            });
          break;
        default:
          break;
      }
    } else {
      this.data.notify("Error al imprimir", "Error", this.data.alertType.error)
    }
  }



  getCliente() {
    this.newfactura.serie_boleta = this.data.getSerieBoleta();
    this.newfactura.serie_factura = this.data.getSerieFactura();
    this.newfactura.show(() => {
      console.log("cerrado");

    })
  }

  showfrmfactura() {
    this.newfactura.serie_boleta = this.data.getSerieBoleta();
    this.newfactura.serie_factura = this.data.getSerieFactura();
    this.newfactura.show(() => {
      this.mostrarFiltro();
      console.log("cerrado");
    })
  }

  showanularfactura(i) {
    this.frmAnulacion.factura = i
    this.frmAnulacion.show(() => {
      this.mostrarFiltro();
      console.log("cerrado");
    })
  }


  modificarVendedor(pedido: Factura) {
    console.log("Validacion: ",!pedido.idvende);
    console.log("ID vendedor actual: ",pedido.idvende);
    
    
    if (!pedido.idvende || pedido.estado == 'ANU') {
      this.data.notify("El pedido no puede cambiar de vendedor", "Error", this.alertType.warning)
      return;
    }
    const modal_pedido = {
      ...pedido,
      idvende : (pedido.idvende as any).idpersonal
    }

    const modalRef = this.modalService.open(ChangePersonalComponent, {
      windowClass: 'modal-animado', // ← Usar windowClass para animaciones
      backdropClass: 'backdrop-animado',
      centered: true,
      size: 'md'
      
    });

    //pasar datos al modal
    modalRef.componentInstance.pedido = modal_pedido;
    modalRef.result.then((resultado) => {
      console.log('Modal cerrado con:', resultado);
    }).catch((error) => {
      console.log('Modal descartado:', error);
    });
  }
}
